


import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ItiIconButton extends Vue {

    @Prop() icon!: string;
    @Prop() tooltip!: string;

    public onClick() {
        this.$emit('click');
    }
}
